import { Component, HostListener } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
// import { CommondatasService } from '../shared/services/commondatas.service';
import { Store, select } from '@ngrx/store';
import * as actions from '../shared/store/region.action';
import { selectRegionValue } from '../shared/store/region.selector';

@Component({
  selector: 'app-docs-mobi',
  templateUrl: './docs-mobi.component.html',
  styleUrls: ['./docs-mobi.component.css']
})
export class DocsMobiComponent {

  region!: string;
  wid!: number;
  
  constructor(private router: Router, private store: Store) {

    this.onWindowResize();
    setTimeout(() => {this.scrollToTop()}, 200);

    store.pipe(select(selectRegionValue)).subscribe((reg) => {
      if(reg===''){
        if(window.sessionStorage.getItem('region')){
          this.sendRegionName(window.sessionStorage.getItem('region')!);
        }
        else{
          this.sendRegionName('Malaysia');
        }
        this.scrollToTop();
      }
    });

 
  }

   @HostListener('window:resize', ['$event'])
   onWindowResize() {
     this.wid = window.innerWidth;
     // window.innerHeight;
   }

  sendRegionName(region: string){
    this.region = region; 
    window.sessionStorage.setItem('region', region);
    this.store.dispatch(actions.switchRegion({country: region}));
  }

  scrollToTop() {
    document.getElementById('maincontent')?.scrollIntoView({ block: 'start', behavior: 'smooth'});
  }

}
